
export class StringHelper {
  public static isString(value: any): boolean {
    return Object.prototype.toString.call(value) === '[object String]';
  }

  public static stringToEnum<T extends { [key: string]: string }>(enumObj: T, str: string): T[keyof T] | undefined {
    const enumValues = Object.values(enumObj) as T[keyof T][];
    return enumValues.find((value) => value === str);
  }

  public randomCode(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++)
      result += characters.charAt(Math.floor(Math.random() * charactersLength));

    return result;
  }
}
